import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../Services/api";
import { usePentagovContext } from "./pentagovContext";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [operador, setOperador] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authReady, setAuthReady] = useState(false);

    const { resetaVariaveis } = usePentagovContext();

    useEffect(() => {
        const token = localStorage.getItem("authToken");

        if (token) {
            try {
                const decoded = jwtDecode(token);
                const operadorInfo = decoded.user.payload.Operador;
                const exp = decoded.exp * 1000; // em ms

                if (Date.now() >= exp) {
                    console.warn("Token expirado");
                    logout(true);
                } else {
                    setOperador(operadorInfo);
                    setIsAuthenticated(true);
                }
            } catch (err) {
                console.warn("Token inválido");
                logout(true);
            }
        }

        setAuthReady(true);
    }, []);

    const login = async (email, senha) => {
        try {
            const formData = new FormData();
            formData.append("email", email);
            formData.append("senha", senha);

            const response = await api.post("/auth/login", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                const { token, refreshToken } = response.data;
                localStorage.setItem("authToken", token);
                localStorage.setItem("refreshToken", refreshToken);

                const decoded = jwtDecode(token);
                const operadorInfo = decoded.user.payload.Operador;
                setOperador(operadorInfo);
                setIsAuthenticated(true);
                return { success: true };
            } else {
                return { success: false, message: response.data.errors?.default };
            }
        } catch (error) {
            return { success: false, message: error.message };
        }
    };

    const logout = (showMessage = false) => {
        setOperador(null);
        setIsAuthenticated(false);
        localStorage.clear();
        resetaVariaveis();
        if (showMessage) {
            localStorage.setItem("toastLogout", "Sua sessão expirou. Por favor, faça login novamente.");
        }
        window.location.href = "/";
    };

    return (
        <AuthContext.Provider
            value={{
                operador,
                isAuthenticated,
                authReady,
                login,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthContext = () => useContext(AuthContext);
